import React from 'react';
import { Box, Typography } from '@mui/material';

const SettingsPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Compliance Settings</Typography>
      <Typography>Settings page coming soon...</Typography>
    </Box>
  );
};

export default SettingsPage;
